import { Row, Col, Input, Button } from 'reactstrap';

const CustomRoadHeader = ({}) => {
  return (
    <div className="invoice-list-table-header w-100 me-1 ms-50 mt-2 mb-75">
      <Row>
        <Col xl="6" className="d-flex align-items-center p-0">
          <div
            className="d-flex align-items-center w-100"
            style={{
              color: '#6D6B7B',
              fontSize: 18
            }}
          >
            Historial de Caminos
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CustomRoadHeader;
